import { ProviderButtons } from './ProviderButtons';
import { MessagePage } from '../components/common';
import { WHATSAPP_HREF } from './whatsapp';
import { CustomerRefused } from './CustomerRefused';

// The customer's sign-in page — R-IN-4, and prototype flow 1.6.
//
// TWO WAYS PEOPLE ARRIVE HERE, and the page cannot tell them apart, so it does
// not try. Somebody registered, on a new phone, who kept the only Beeches Brook
// URL they ever had — their own registration link — and followed it after it
// expired or after they had finished on it. And somebody who reached
// `/signin` directly, which is the durable address a customer can bookmark.
//
// It says nothing about a household, because at this point it knows of none:
// the link that brought them here is spent, and the identity behind the
// provider button is what decides where they land. Signing in with the account
// that registered lands on Home; signing in with anything else is refused.
export function CustomerSignIn({ refused = null }: { refused?: string | null } = {}) {
  // The callback sends a customer-shaped sign-in that no household holds back
  // here with `?refused=unknown` (customer-sign-in-registration AC36, AC38),
  // and the page it draws is the refusal — one plain page that gives a
  // stranger nothing to learn from.
  if (refused === 'unknown') return <CustomerRefused />;
  return (
    <MessagePage
      title="Sign in"
      lead="Use the account you registered with and you will land straight on your stays."
      actions={<ProviderButtons />}
      foot={
        <>
          Apple sign-in is coming — use Google or Microsoft for now. Not registered yet, or signed in and
          getting nowhere?{' '}
          <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer">
            message Patricia
          </a>{' '}
          and she will send you a link.
        </>
      }
    />
  );
}
